import { useQuery } from '@tanstack/react-query';

import { EventsService } from '../services';

const key = 'model_outputs';

export const useModelOutputsQuery = (eventId: number) => {
  const queryKey = [key, eventId];

  const queryFn = () => EventsService.getModelOutputs(eventId);

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!eventId,
  });
};
